// ZODIAC APP PAGE
export const zodiacAppContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Web Apps
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'Zodiac App', size: 'h1' },
        {
          type: 'text',
          content: 'Explore your cosmic identity',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'An astrology and zodiac application featuring horoscopes, birth chart analysis, and compatibility insights.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <span style={{
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '600'
            }}>
              Completed
            </span>
          )
        }
      ]
    },

    {
      id: 'features',
      title: 'Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                { icon: '♈', title: 'Daily Horoscopes', desc: 'Personalized readings for each sign' },
                { icon: '🌙', title: 'Birth Charts', desc: 'Detailed natal chart analysis' },
                { icon: '💕', title: 'Compatibility', desc: 'Check romantic and friend matches' },
                { icon: '🌟', title: 'Personality Traits', desc: 'Deep dive into zodiac characteristics' }
              ].map((feature, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)'
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '12px' }}>{feature.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0 }}>{feature.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    {
      id: 'tech',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {['Next.js', 'React', 'Astrology APIs', 'Tailwind CSS'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>{tech}</span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'Zodiac App',
    text: 'Discover what the stars have in store',
    button: { text: 'See more work →', url: '/' }
  }
};
